// extracted by mini-css-extract-plugin
export var button = "styles-module--button--10cf2";
export var container = "styles-module--container--d9b9f";
export var image = "styles-module--image--cc346";
export var imageBox = "styles-module--imageBox--d2734";
export var imageLeft = "styles-module--imageLeft--08965";
export var imageRight = "styles-module--imageRight--b308e";
export var info = "styles-module--info--6d704";
export var parentContainer = "styles-module--parentContainer--da06f";
export var svg = "styles-module--svg--a08b9";
export var svgBox = "styles-module--svgBox--8bcd7";
export var text = "styles-module--text--ad465";